export default {
  message: {
    home: '首页',
    PleaseEnter: '请输入',
    PleaseEnterConsole: '请输入IMEI/用户名/用户账号，可模糊查询',
    PleaseSelect: '请选择',
    Select: '搜索',
    Reset: '重置',
    Add: '新增',
    Edit: '编辑',
    Detial: '详情',
    ResetPassword: '重置密码',
    Confirm: '确认',
    Cancel: '取消',
    Operate: '操作',
    showTotal1: '共',
    showTotal2: '项数据',
    ExpandCollapse: '展开/收起',
    Delete: '删除',
    Inquire: '查询',
    SelectAll: '全选',
    DeleteBulk: "批量删除",
    SellBulk: "批量销售",
    Import: "导入",
    UploadFileMsg1: "点击或拖拽文件到此处上传",
    UploadFileMsg2: "支持 .xlsx 和 .xls 文件",
    UploadFileMsgsuc: "文件上传成功!",
    UploadFileMsgerr: "文件上传失败: ",
    DownloadTemplate: "下载模板",
    ExportToExcel1: "请选择数据后导出哦！！！",
    ExportToExcel2: "正在导出，请稍后……",
    fail: "失败",
    success: "成功",
    DownloadFile: "正在下载请稍后……",
    DownloadCompleted: "下载完成。",
    More: "更多",
    Other: "其他",
    Wait: "请稍后…… ",
    Complete: "完成",
    BaseTitle: '瑞腾Web后台管理系统',
    LoginSuccess:'登录成功，欢迎回来',
    LoginNo:'请输入账号',
    LoginPwd:'请输密码',
    prompt:'提示',
    Sendsuccess:'发送成功',
    ToolTipmessage: "确认导出为Excel吗？",
    Uploadsuccessful: "请等待文件上传完成之后再提交！",
  },
  EditBUser: {
    UserName: '用户名',
    LoginAccount: '登录账号',
    Role: '角色',
    State: "状态",
    DeleteBUserTips: '是否确认删除此用户，用户删除后无法恢复。',
    Enable: '启用',
    Disable: '禁用',
    Setpassword: '设置密码',
    DeleteBUserTitle1: '确认要删除',
    DeleteBUserTitle2: '用户吗？',
    SwitchBUserTitle1: '确认要',
    SwitchBUserTitle2: '用户吗？',
    Enable: '启用',
    disable: '停用',
    Belongingcompany: '所属公司',
    PasswordTips: '密码必须为6~20位字符,可包含大小写字母、数字和特殊字符。',
    rules: {
      OrgId: '请选择所属公司',
      UserName: '请输入用户名',
      LoginName: '请输入登录账号',
      RoleId: '请选择角色',
      Passwordtips1: '请设置密码',
      Passwordtips2: '密码必须位6~20位字符!',
      State: '请选择状态'
    },
    ResetPwdTips1: '密码必须6~20位字符,可包含大小写字母、数字或特殊字符。',
    ResetPwdTips2: '例:8aZ@01',
    ResetFormTitle1: '请输入',
    ResetFormTitle2: '的新密码',
  },
  RoleMgr: {
    RoleName: '角色名称',
    DeleteRoleContent: '是否确认删除此角色，角色删除后无法恢复。',
    title: {
      SerialNumber: '序号',
      RuleName: '规则名',
      Notes: '备注',
    },
    model: {
      DeleteRoleTitle1: '确认要删除',
      DeleteRoleTitle2: '角色吗？',
      SwitchRoleTitle1: '确认要',
      SwitchRoleTitle2: '角色吗？',
      Enable: '启用',
      disable: '停用',
      State1: '启用',
      State2: '停用',
    },
    Permissionmenu: '权限菜单',
    Normal: '正常',
    rules: {
      Menulist: '请至少选择一个菜单',
      RoleName: '请输入规则名',
      State: '请选择状态'
    },
    REQUIRED: '验证失败，检查必填',
  },
  MenuMgr: {
    Menuname: '菜单名称',
    DeleteContent: '是否确认删除此菜单，菜单删除后无法恢复。',
    Path: '路径',
    Icon: '图标',
    Sort: '排序',
    DeleteTitle1: '确认要删除',
    DeleteTitle2: '菜单吗？',
    SwitchTitle1: '确定要',
    SwitchTitle2: '菜单吗？',
    Enable: '启用',
    Deactivate: '禁用',
    Parentmenu: '上级菜单',
    ProjectType: '项目类型',
    MenuIcon: '菜单图标',
    MenuName: '菜单名称',
    DisplaySorting: '显示排序',
    Navigation: '导航',
    Page: '页面',
    Button: '按钮',
    rules: {
      Type: '请选择类型',
      Title: '请输入菜单名称',
      State: '请选择状态',
    },
    Addmenu: '新增菜单',
    Editmenu: '编辑菜单',
  },
  OrgMgr: {
    CompanyName: '公司名称',
    Country: '国家',
    Delete: '是否确认删除此公司，公司删除后无法恢复。',
    DeleteTitle1: '确认要删除',
    DeleteTitle2: '公司吗？',
    ParentCompany: '上级公司',
    rules: {
      ParentId: '请选择上级公司',
      Name: '请输入公司名称',
      CountryId: '请选择国家',
    },
    AddMenu: 'Add Menu',
  },
  menu: {
    首页: '首页',
    B端用户管理: 'B端用户管理',
    C端用户管理: 'C端用户管理',
    产品设备: '产品设备',
    研发管理: '研发管理',
    用户管理: '用户管理',
    角色管理: '角色管理',
    菜单管理: '菜单管理',
    公司管理: '公司管理',
    设备管理: '设备管理',
    App版本管理: 'App版本管理',
    App推送配置: 'App推送配置',
    产品用户数据: '产品用户数据',
    软件功能数据: '软件功能数据',
    客户数据: '客户数据',
    协议配置: '协议配置',
    用户详情: '用户详情',
    新增协议: '新增协议',
    编辑协议: '编辑协议',
    APP与设备功能配置: 'APP与设备功能配置',
    新增APP与设备功能配置: '新增APP与设备功能配置',
    配置详情: '配置详情',
    自助集成: '自助集成',
    预警信息: '预警信息',
    控制台: '控制台',
    设备APP版本管理: '设备APP版本管理',
    登录: '登录',
    Login: '登录',
    蓝牙表盘管理: '蓝牙表盘管理',
    瑞腾智能数据平台: '瑞腾智能数据平台',
    在线表盘管理: '在线表盘管理',
    角色详情:'角色详情',
    APN管理:'APN管理',
    协议文档管理:'协议文档管理',
    在线协议文档:'在线协议文档',
    设备日志查询:'设备日志查询',
    定位次数数据:'定位次数数据',
  },
  VersionMgr: {
    PhoneSystems: '手机系统',
    EmailConfiguration: '邮箱配置',
    DownloadPageConfiguration: '下载页面配置',
    DeleteContent: '是否确认删除此版本，版本删除后无法恢复。',
    Title: {
      VersionNo: '版本号',
    },
    DeleteTitle1: '确认要删除',
    DeleteTitle2: '的版本吗？',
    UserId: '用户ID',
    Email: '邮箱',
    Pwd: '密码',
    SMTPServer: 'SMTP服务器',
    SMTPPort: 'SMTP端口',
    SmtpUseSSL: 'SMTP是否用SSL',
    rules: {
      VersionNo: '请输入版本号',
      UserId:'请输入用户ID',
      Email:'请输入邮箱',
      Pwd:'请输入密码',
      SMTPServer:'请输入SMTP服务器',
      SMTPPort:'请输入SMTP端口',
    },
    AddVersionNo: '新增App版本',
    EditVersionNo: '编辑App版本',
    APPIcon: 'APP图标',
    APPDetial: 'APP简介',
    AndroidDownQRPath: '安卓下载二维码',
    IOSDownQRPath: 'IOS下载二维码',
    DownLoadPagePtah: '下载页背景图',
    SelectFile: '选择文件',
    OnlyFile: '请选择一份图片上传!',
    FileTypeCheck: '只能上传后缀是.jpg/.jpeg/.png',
    FileSizeCheck: '文件大小不能超过10M',
  },
  PushMgr: {
    JPush: '极光',
    DownloadPage: '下载页面',
    Yes: '是',
    No: '否',
    DeleteContent: '是否确认删除此推送配置，推送配置删除后无法恢复。',
    Title: {
      APPCode: 'APP编码',
      ApplicationName: 'APP名称',
      JPushKey: '极光Key',
      JPushSecret: '极光Secret',
      WhetherToDevelop: '是否开发',
    },
    DeleteTitle1: '确认要删除',
    DeleteTitle2: '推送配置吗？',
    rules: {
      ClientType: '请输入APP编号',
    }
  },
  ProtocolMgr: {
    ProtocolEncoding: '协议编码',
    ProtocolName: '协议名',
    DeleteContent: '是否确认删除此协议配置,协议配置删除后将无法恢复',
    title: {
      Describe: '描述',
      ProtocolList: '协议列表',
      InstructionEncoding: '指令编码',
      InstructionName: '指令名',
    },
    DeleteTitle1: '是否要删除',
    DeleteTitle2: '协议配置吗？',
    ProtocolDetial: '协议详情',
    ProtocolInstruction: '协议指令',
    SelectInstruction: '选择指令',
    Clear: '清除',
    AddPrtocolSuccessMsg1: '创建成功',
    AddPrtocolSuccessMsg2: '协议配置创建成功,您可协议配置列表进行查看',
    AddProtocolSuccessBtn: '返回协议配置列表',
    rules: {
      protocolCode: '请输入协议编码',
      protocolName: '请输入协议名',
    },
    EditPrtocolSuccessMsg1: '编辑成功',
    EditPrtocolSuccessMsg2: '协议配置编辑成功,您可协议配置列表进行查看',
  },
  AppDeviceFuncMgr: {
    Tips:"提示",
    DeviceType: '设备类型',
    DeviceTypeTitle: {
      Children: '儿童',
      Elderly: '老人',
      QUBE: '车机',
      Luggage: '行李箱',
      Positioner: '定位器',
      PoliceLocator: '警用定位器',
    },
    funcArr: {
      LBSPositioning: 'LBS定位',
      EquipmentFence: '设备围栏',
      OnboardEquipment: '车载设备',
      QuantityOfElectricity: '电量',
    },
    DeleteContent: '是否确认删除此App与设备功能配置,配置删除后将无法恢复',
    Protocol: '协议',
    EquipmentFunctionSupport: '设备功能支持',
    DeleteMgs1: '是否要删除',
    DeleteMgs2: '的功能配置吗？',
    AddForm: {
      BasicSettings: '基础设置',
      FunctionSettings: '功能设置',
      CompleteCreation: '完成创建',
      Protocol: '厂商协议',
      NextStep: '下一步',
      SelectFunction: '选择功能',
      FilterTimeFunction: '过滤时间功能',
      FilterMinute: '过滤时间(分钟)',
      FunctionalSupport: '功能支持',
      AudioFunction: '音频功能',
      ThirdPartyAudio: '第三方音频',
      Audio0: '无',
      Audio2: '网易',
      Audio3: '融云',
      Audio4: '菊风',
      Audio5: '声网',
      FenceDetectionFunction: '围栏检测功能',
      EntryAndExitFenceDetectionMethod: '进出围栏检测方式',
      AppFeatures: 'App功能',
      APPFunctionSupport: 'APP功能支持',
      CommandHead: '指令头',
      FriendFunction: '好友功能',
      NumberOfFriends: '好友个数',
      HealthFunction: '健康功能',
      HealthConfiguration: '健康配置',
      StepCountingType: '计步类型',
      FenceFunction: '围栏功能',
      NumberOfFences: '围栏个数',
      APPIntervalFunction: 'APP间隔功能',
      APPIntervalFunctionConfiguration: 'APP间隔功能配置',
      PowerFunction: '电量功能',
      IsTheBatteryLevelDisplayed: '是否展示电量',
      TextExpressionFunction: '文本表情功能',
      ChatType: '聊天类型',
      WeChatOfflineTextEmoticons: '微聊离线文本表情',
      Support: '支持',
      NotSupported: '不支持',
      DeviceApplicationGames: '设备应用游戏',
      DeviceApplicationGameConfiguration: '设备应用游戏配置',
      PreviousStep: '上一步',
      SuccessMsg2: '功能配置创建成功,您可通过App与设备功能配置列表页进行查看',
      SuccessBtn: '返回功能列表配置页',
      Clear: '清空',
      Notenabled: '未启用',
      enabled: '启用',
      Alarmrange: '报警范围',
      AlarmrangeM: '报警范围（米）',
    },
    rules: {
      DeviceModelName: '请输入设备型号',
      Protocol: '请选择协议',
      DeviceType: '请选择设备类型',
      FunctionSupport: '请选择功能支持',
      AppFunc: '请选择App功能支持',
      Name:'请输入型号名称',
      AlarmRange:'请输入正确的范围'
    },
    SelectList: {
      ImmediatelyLocate: '立即定位',
      Intercom: '对讲',
      Album: '相册',
      TouchAndMakeFriends: '碰碰交友',
      MakePhoneCall: '拨打电话',
      VideoCall: '视频通话',
      VoiceCall: '语音通话',
      Step: '记步',
      Sleep: '睡眠',
      HeartRate: '心率',
      BloodPressure: '血压',
      Temperature: '温度',
      BloodOxygen: '血氧',
      BloodSugar: '血糖',
      IsStepSum1: '非累加 凌晨清零',
      IsStepSum2: '累加 凌晨不清零',
      IsStepSum3: '累加 每小时清零',
      HeartRateInterval: '心率间隔',
      BloodPressureInterval: '血压间隔',
      BloodOxygenInterval: '血氧间隔',
      TemperatureInterval: '温度间隔',
      WearInterval: '佩戴间隔',
      SedentaryInterval: '久坐间隔',
      WechatType0: '群聊',
      WechatType1: '单聊',
      WechatType2: '群聊+单聊',
      WechatType3: '群聊+单聊+文字',
      WechatType4: '群聊+单聊+文字+表情',
    },
    EditForm: {
      BasicEquipmentSettings: '设备基础设置',
      Save: '保存',
      EditSuccessMsg2: '功能配置编辑成功,您可通过App与设备功能配置列表页进行查看',
      EditSuccessBtn: '返回功能列表配置页',
      Term: '项',
    },
  },
  LayOut: {
    Default: '默认',
    LargeSize: '大号',
    PersonalInformation: '个人信息',
    SystemSettings: '系统设置',
    LogOut: '退出登录',
    RefreshCurrent: '刷新当前',
    CloseOther: '关闭其他',
    ChangeLanguage: 'EN',
  },
  CUserList: {
    UserName: '用户名',
    LoginAccount: '注册账号',
    CompanyName: '公司名称',
    DeviceModel: '设备型号',
    IMEI: 'IMEI',
    DeviceName: '设备名称（IMEI）',
    DeviceNameNULL: '暂无名称',
    DeviceNULL: '暂无设备',
    UserDetails: '用户详情',
    DeviceMgr: '设备管理',
    UnbindDeviceTitle1: '确定要解绑"',
    UnbindDeviceTitle2: '"设备吗？',
    UnbindDeviceMsg: '是否确认解绑此设备，设备解绑后将无法获取设备数据。',
    UnbindDeviceMsginfo: '已为您解绑设备：',
    UnbindDeviceMsginfoerr: '发生错误未能解绑设备：',
    ExportMsg: '正在导出，请稍后……',
    ExcelFileName: '用户设备列表_',
  },
  UserDetails: {
    UserDetails: '用户详情',
    Height: '身高',
    Weight: '体重',
    LifeStress: '生活压力',
    LifeStress0: '毫无压力',
    LifeStress1: '能承受',
    LifeStress2: '非常大',
    DietaryStandards: '饮食目标',
    DietaryStandards1: '减脂',
    DietaryStandards2: '健康',
    DietaryStandards3: '增肌',
    LastLoginTime: '最近登录时间',
    ActiveDays: '近30天活跃天数',
    DeviceMgr: '设备管理',
    MoreDevices: '更多设备',
    BindingDevices: '绑定设备：',
    DeviceNameNULL: '暂无名称',
    IMEI: '设备IMEI：',
    DeviceStatus: '设备状态：',
    DeviceStatus2: '异常',
    DeviceStatus0: '正常',
    DeviceStatus1: '离线',
    DeviceStatusall: '激活',
    OperatingEquipment: '操作设备：',
    UnbindDevice: '解绑设备',
    LocationData: '定位数据',
    StepData: '记步数据',
    HeartRateData: '心率数据',
    BloodOxygenData: '血氧数据',
    SleepData: '睡眠数据',
    BloodPressureData: '血压数据',
    BatteryData: '设备电量',
    RealtimeLocationData: '实时定位数据',
    ViewMap: '查看地图',
    HistoricalTrajectory: '历史轨迹',
    DevicePower: '设备电量',
    TargetingType: '定位类型',
    TargetingTypenull: '无效',
    SignalTime: '信号时间',
    PositioningTime: '定位时间',
    PhysicalLocation: '实际位置',
    Day: '天',
    all: '全部',
    formatmonth: '月',
    formatday: '日',
    EditCUser: {
      EditUserTitle: '编辑用户信息',
      UserName: '用户名',
      CellPhone: '手机号',
      Address: '居住地址',
      Height: '身高',
      Weight: '体重',
      LifeStress: '生活压力',
      LifeStress0: '毫无压力',
      LifeStress1: '能承受',
      LifeStress2: '非常大',
      DietaryStandards: '饮食目标',
      DietaryStandards1: '减脂',
      DietaryStandards2: '健康',
      DietaryStandards3: '增肌',
      EditedSuccess: '修改成功',
      EditFailed: '发生错误修改失败',
      ValidationFailed: '验证失败',
      rules: {
        UserName: '用户名不能为空',
        CellPhone: '手机号不能为空',
        Address: '居住地址不能为空',
        Height: '请输入正确的身高',
        Weight: '请输入正确的体重',
        Number: '请输入有效的数字',
      },
    },
    BloodData: {
      BloodPressureData: '血压数据',
      ShrinkMax: '收缩-Max',
      ShrinkMin: '收缩-Min',
      DiastolicMax: '舒张-Max',
      DiastolicMin: '舒张-Min',
    },
    BloodOxygenDatamenu: {
      BloodOxygenData: '血氧数据',
      BloodOxygenMax: '血氧-Max',
      BloodOxygenMin: '血氧-Min',
    },
    HeartRateDatamenu: {
      HeartRateData: '心率数据',
      HeartRateMax: '心率-Max',
      HeartRateMin: '心率-Min',
      HeartRateyAxis: '次/分',
    },
    SleepDatamenu: {
      SleepData: '睡眠数据',
      Sober: '清醒',
      LightSleep: '浅睡',
      QuickRotation: '快速翻滚',
      DeepSleep: '深睡',
      SleepAxis: '分钟',
    },
    StepDatamenu: {
      StepData: '记步数据',
      StepDatayAxis: '步',
    },
    BatteryDatamenu: {
      BatteryData: '设备电量',
      today: '今天',
      Hour: '小时',
    }
  },
  CUserDeviceMgr: {
    DeviceNameNULL: '暂无名称',
    DeviceStatus2: '异常',
    DeviceStatus0: '正常',
    DeviceStatus1: '离线',
    DeviceStatusall: '激活',
    Unbind: '解绑',
    IMEI: 'IMEI：',
    ActiveDate: '激活时间：',
    FirmwareVer: '软件版本：',
    VersionNo: 'App版本：',
    CompanyName: '隶属公司：',
    RelationName: '账号关系：',
    Devicelog: '设备日志：',
    looklog: '查看日志',
    DeviceAlarmlog: '报警日志：',
    UnbindDeviceTitle1: '确定要解绑"',
    UnbindDeviceTitle2: '"设备吗？',
    UnbindDeviceMsg: '是否确认解绑此设备，设备解绑后将无法获取设备数据。',
    UnbindDeviceMsginfo: '已为您解绑设备：',
    UnbindDeviceMsginfoerr: '发生错误未能解绑设备：',
    Devicelogopen: '已打开设备日志：',
    DeviceAlarmlogopen: '已打开报警日志：',
    Devicelognull: '今天无该设备的日志：',
  },
  LocationDataMap: {
    DeviceNameNULL: '暂无名称',
    InfoWindowmsg: '这是设备的最近一次的定位位置',
  },
  HistoricalTrajectoryMap: {
    GPS: '卫星定位',
    LBS: 'LBS定位',
    WIFI: 'WIFI定位',
    fast: '快',
    slow: '慢',
    Play: '播放',
    Stopit: '停止',
    Timeout: '暂停',
    Instructionsmsg: '关于回放时间范围：一般情况下只保留2个月的历史定位数据。',
    Instructions: '回放说明',
    modeltitle: '提示',
    modelmsg: '该时间段无数据，注意定位时间段和定位方式的选择。',
    Locations: '定位类型多选时，则只能等待动画为最后一个或者完成，还可以刷新重新进入该页面',
    NoTime: '未选择时间段，无法跟踪轨迹',
    NoLocation: '未选择定位类型，无法跟踪轨迹',
    GPSLocation: '当前是卫星定位轨迹',
    LBSLocation: '当前是LBS定位轨迹',
    WIFILocation: '当前是WIFI定位轨迹',
    LocationNoData: '当前定位方式无数据',
    GPSNOLocation: '卫星定位方式无数据',
    LBSNOLocation: 'LBS定位方式无数据',
    WIFINOLocation: 'WIFI定位方式无数据',
    Locationtypeerr: '定位类型选择方式不对，无法跟踪轨迹',
    LocationType: '定位类型',
    Unknown: '未知',
    Enableranging: '开启测距',
    Turnoffranging: '关闭测距',
  },
  Devices: {
    IMEI: "IMEI",
    IMEIInput: "请输入，可以多IMEI用“,”间隔查询",
    DeviceName: "设备名称",
    DeviceModel: "设备型号",
    CompanyName: "公司名称",
    Created: "创建时间",
    Created1: "入库时间",
    Operators: "运营商",
    Battery: "电量",
    LastCommunication: "最后通讯时间",
    ActiveDate: "激活时间",
    DeleteDeviceMsg: "是否确认删除设备，设备删除后将无法恢复。",
    AddDevice: "新增设备",
    EditDevice:"编辑设备信息",
    Model: "模型",
    ImportDevice: "导入设备",
    DeviceNum: "设备数量",
    Device: "设备",
    DeviceTotal: "设备总数",
    DevicesStatistics: "设备统计",
    ManageDeviceUsers:"管理设备用户",
    DevicLogs:"设备日志",
    DisconnectioDetails:"今日掉线详情",
    BatteryData:"设备电量",
    BasicInformation:"设备基础信息详情",
    UnbindDevice1:"确认要解绑设备吗？",
    UnbindDevice2:"是否确认解绑设备，用户与设备解绑后将断开绑定关系。",
    OfflineDetails:"设备今天掉线详情",
    OfflineTime:"掉线时间",
    Customer:"客户名",
    Relationship:"关系名",
    MainControl:"是否为主控号",
    YES:"是",
    NO:"否",
    Unbind:"解绑",
    LoginAccount:"登录账号",
    LoginPassword:"登录密码",
    message:{
      NotBound:"设备未绑定",
      NotBoundUser:"当前设备暂无绑定用户,请通过APP绑定设备之后再尝试",
      LoginAccount:"请输入登录账号",
      LoginPassword:"请输入登录密码",
    },
    Statistics_of_positioning_times:"定位次数统计",
    positioning_times:"定位次数",
    locationCountTime:{
      one_day:"1天",
      one_month:"1个月",
      three_months:'3个月',
      six_months:'6个月',
      one_year:'一年',
    }
  },
  PersonInfo: {
    Upload: '上传',
    BasicInformation: '基础信息',
    UserName: '用户名称',
    Email: '邮箱',
    PhoneNumber: '手机号码',
    Role: '用户角色',
    CreationTime: '创建时间',
    ResetPassword: '重置密码',
    OldPassword: '旧密码',
    NewPassword: '新密码',
    ConfirmPassword: '确认密码',
    rules: {
      UserName: '请输入用户名',
      Email: '请输入用户邮箱',
      PhoneNumber: '请输入手机号码',
      OldPwd: '请输入原密码',
      NewPwd: '请输入新密码',
      ConfirmPwd: '请再次输入新密码',
      PwdTips: '新密码长度不能少于6位',
    },
    PersonalInformation: '个人信息',
    ConfirmPasswordInconsistency: '确认密码不一致',
  },
  ExceptionMessage: {
    AlarmType: '报警类型',
    NotificationType110: '跌倒报警',
    NotificationType5: 'SOS报警',
    NotificationType97: '血糖偏低',
    NotificationType139: '血压异常',
    NotificationType997: '血糖偏低',
    NotificationType998: '血糖偏高',
    NotificationType3: '低电报警',
    NotificationType65: '脱落报警',
    NotificationType202: '设备连接充电器',
    NotificationType203: '设备断开充电器',
    NotificationType1: '进电子围栏报警',
    NotificationType2: '出电子围栏报警',
    NotificationType140: '心率异常',
    NotificationTypeNone: '其他报警',
    TypeSelect: {
      FallAlarm: '跌倒报警',
      SOSAlarm: 'SOS报警',
      AbnormalHealthData: '健康数据异常',
      DeviceAbnormality: '设备异常',
      AbnormalPositioning: '定位异常',
    },
    AlarmTime: '报警时间',
  },
  ConsolePage: {
    CommonFunctions: '常用功能',
    EquipmentManagement: '设备管理',
    Roles: '角色管理',
    BigScreenData: '大屏数据',
    WarningRecord: '预警记录',
    More: '更多',
    Menu: "菜单管理列表",
    Org: "公司管理列表",
    Role: "角色管理列表",
    BUser: '用户管理列表',
    AppDeviceFunc: 'APP与设备功能配置列表',
    Protocol: '协议配置列表',
    JPush: '极光推送列表',
    HmsPush: 'Hms推送列表',
    AppVersion: 'App版本管理列表',
    Exception: '预警信息列表',
  },
  DevicesListMgr: {
    ExportToExcelName: "设备列表_",
    DeleteDevicemsgtitle1: "确定要删除设备吗？",
    DeleteDevicemsgtitle2: '确定要删除"',
    DeleteDevicemsgtitle3: '"设备吗？',
    rulesImeis: 'IMEI不能为空',
    rulesDeviceName: '设备名称不能为空',
    rulesDeviceModel: '请选择设备型号',
    rulesCompanyCode: '请选择隶属公司',
    TempName: "设备批量导入模板.xlsx",
  },
  CustomerData: {
    CustomerDistribution: {
      CustomerDistribution: '客户分布',
      CustomerDistributionDataName: '客户分布数据_',
    },
    CustomerDataStatistics: "客户数据统计",
    NumberPlatformUsers: "平台用户数",
    NumberCustomers: "客户数量",
    NumberCustomerspopover: "使用平台的客户数量",
    EquipmentStatistics: "设备统计",
  },
  SoftwareFunctionalData: {
    SoftwareFunctionDataDtatistics: "软件功能数据统计",
    Function: "功能",
    Data: "数据",
    OldPeople: "老人",
    Children: "儿童",
    NumberFunctionActivations: "功能激活次数"
  },
  HealthData: {
    HeartRate: "心率",
    BloodOxygen: "血氧",
    Sleep: "睡眠",
    Steps: "记步",
    BloodPressure: "血压",
  },
  Charts: {
    AccountFor: "占比",
    flushed: "刷新当前",
    exportPng: "下载PNG图像",
    exportJpg: "下载JPEG图像",
    exportPdf: "下载PDF文档",
    exportSvg: "下载SVG矢量图像",
    flushedOver: "刷新完成",
    None: "暂无",
  },
  UserProductData: {
    ProductUserDataStatistics: "产品用户数据统计",
    ALLDevices: "所有设备型号的总数",
    SinceLastWeek: "自从上周以来",
    TotalUsers: "总用户数",
    ALLUsers: "所有注册帐号的总数",
    CommonUsersNum: "常用人数",
    CommonUsersNum1: "三天内部使用设备的总数",
    CommonUsersNum2: "（三天内用过一次以上）",
    UserActivity: "用户活跃度",
    Week: "周",
    Month: "月",
    UserDistribution: "用户分布",
    ActivatedDevicesNum: "激活设备数",
    DevicesOnlineNum: "设备在线人数",
  },
  Week: {
    Sun: "周日",
    Mon: "周一",
    Tue: "周二",
    Wed: "周三",
    Thu: "周四",
    Fri: "周五",
    Sat: "周六",
  },
  DeviceAppList: {
    AppCode: "App标识",
    AppName: "App名称",
    AppIcon: "App图标",
    Appbag: "APK文件",
    Appversion: "App版本",
    DownloadUrl: "下载地址",
    IconUrl: "图标地址",
    DeleteAPPTips: "删除后将无法恢复数据",
    DeleteAPPTips1: "确认删除名为：",
    DeleteAPPTips2: "的设备应用吗？",
    DeleteAPPmsg: "已成功删除APPCode为：",
    DeleteAPPmsg1: "的设备应用",
    AddDeviceAPP: "新增设备应用",
    EditDeviceAPP: "编辑设备应用信息",
    UploadFileMsg2: "只支持.apk文件",
    UploadFileMsg3: "只支持.jpg,.png,.jpeg,.ico文件",
    rulesAppversion: "版本号不可为空",
    rulesAppName: "应用名称不可为空",
    ExportMsg: '正在导出，请稍后……',
    ExportToExcelName: '设备APP列表',
    SelectFile: "请选择文件",
    UpdateFile: "此APP已存在，已自动为你更新",
  },
  Login: {
    Account: '账号',
    Pwd: '密码',
    Language: '语言',
    RememberAccount: '记住用户名',
    Login: '登录'
  },
  SelfService: {
    HexadecimalSystem: '16进制',
    StartDebug: '开始调试',
    FinishDebugging: '结束调试',
    FindDevices: '寻找设备',
    MeasureBloodPressure: '测量血压',
    MeasureHeartRate: '测量心率',
    ImmediatelyLocate: '立即定位',
    RestoreFactorySettings: '恢复出厂设置',
    Restart: '重启',
    TakePhotoImmediately: '立即拍照',
    RemoteDeviceUpgrade: '远程设备升级',
    SetUpContacts: '设置联系人',
    StepCountingTarget: '计步目标',
    AlarmClock: '闹钟',
    HideGameSwitch: '隐藏游戏开关',
    StrangerCall: '陌生人通话',
    AutoAnswer: '自动接听',
    DoNotDisturb: '免打扰',
    PositioningTimePeriod: '定位时间段',
    WatchKeyboard: '手表键盘',
    Wiretapping: '电话监听',
    PositioningMethodPriority: '定位方式优先级',
    PositioningTimeInterval: '定位时间间隔',
    IntelligentPositioningSwitch: '智能定位开关',
    SetWatchDialStyle: '设置手表表盘样式',
    SetTheWatchVolume: '设置手表音量',
    SetWatchBrightness: '设置手表亮度',
    Bindingandunbinding: '解绑绑定',
    Devicebindingandunbinding: '设备绑定与解绑',
    Latitudeandlongitude: '经纬度设置',
    Binding: '绑定',
    Unbinding: '解绑',
    GPSworkingtimeperiod: 'GPS工作时间段',
    Instruction: "指令",
    PleaseEnterTheCommand: "请输入指令",
    Send: "发送",
    OutputData: "输出数据",
    Addset: "添加一组",
    CleanUp: '清除',
    Allrequired: '全部必填',
    Positionswitch: '定位开关',
    Videomonitoring: '视频监护',
    Invisibilityperiodduringclass: '上课隐身时间段',
    AloneSwitch: '含独立开关',
    DeviceAppMgr: '设备应用管理',
    Switchthewatchtoconnecttotheserver: '切换手表连接服务器',
    Newvoicerecordingreminder: '新语音记录提醒',
    Notifydevicetoacceptvideocalls: '通知设备接受视频通话',
    Chat: '聊天',
    Shutdown: '关机',
    M1poweronoff: 'M1开关机',
    Controldevicerecord: '控制设备录音',
    Sedentaryreminderswitchintervaltimeperiod: '久坐提醒开关，间隔，时间段',
    Notwearingthedetectioninterval: '未佩戴检测时间间隔',
    Fallalarmswitchandlevel: '跌倒报警开关与等级',
    Inductivemicrophoneswitch: '感应麦克风开关',
    Powersavemodeswitch: '省电模式开关',
    Raiseonscreenswitch: '抬腕亮屏开关',
    Setalarmclockname: '设置闹钟(带名称)',
    VolumeSet: '音量设置',
    Detachmentalarm: '脱落报警开关',
    Pedometerswitch: '计步器开关',
    Eliminatedevicedata: '消除设备数据',
    ChangedeviceUI: '更改设备UI',
    Setserverinformation: '设置服务器信息',
    ChatEmojis307: '聊天文本表情(307平台)',
    AvatarChange: '头像变动通知',
    BPcalibration: '血压校准',
    Sleeptimeperiod: '睡眠时间段',
    Bloodglucosealarmthreshold: '血糖报警阈值',
    Unbindbloodglucosemeter: '解绑血糖仪',
    MBlSimmediately: '立即测量血糖',
    Mtemperature: '测量体温',
    Mthermometer: '体温计测量周期',
    HBOalarmthreshold: '心率/血氧报警阈值',
    MeasureBO: '测量血氧',
    HBMI: '心率血压测量间隔',
    WIFIMAC: 'WIFI MAC设置',
    Onlinewatchface: '设置在线表盘',
    TTQNFCInterfaceswitch: '糖糖圈NFC界面显示开关',
    Functioninterval: '功能间隔',
    LPAtodevice: '下发LPA码到设备',
    Takevideo: '立即拍视频',
    Setcontactsnamesavatars: '设置联系人带名称和头像',
    WIFIGuardian: '自定义WIFI守护',
    WIFIsearch: 'WIFI搜索',
    WIFIsettings: 'WIFI设置',
    SetWIFIswitch: '设置手表WIFI开关',
    phoneWIFIMAC: 'APP下行手机热点Mac地址',
    MobilecloudNotice: '通知设备移动云盘授权通过',
    Notificationmobile: '通知设备开通移动云盘',
    K25hiddenmenu: 'K25隐藏菜单',
    Form: {
      Nickname: '昵称',
      Phone: '电话',
      AllowSOS: '允许SOS',
      TargetSteps: '目标步数',
      Time: '时间',
      SelectTheDayOfTheWeek: '选择星期几',
      Monday: '周一',
      Tuesday: '周二',
      Wednesday: '周三',
      Thursday: '周四',
      Friday: '周五',
      Saturday: '周六',
      Sunday: '周日',
      Enable: '是否启用',
      StartTime: '开始时间',
      EndTime: '结束时间',
      Switch: '开关',
      WhetherWIFITakesPriority: '是否WIFI优先',
      SetPositioningPriority: '设置定位优先级',
      SetPositioningInterval: '设置定位时间间隔',
      WhethertoEnableIntelligentPositioning: '是否开启智能定位',
      Islocationtrackingenabled: '是否开启定位',
      Whethertostartvideomonitoring: '是否启动视频监护',
      ALLSwitch: '总开关',
      PleaseEnterTheWatchDialStyleNumber: '请输入手表表盘样式编号',
      WatchVolume: '手表音量',
      WatchBrightness: '手表亮度',
      Please_enter_the_target_number_of_steps: '请输入目标步数',
      Only_positive_integers_can_be_entered: '只能输入正整数',
      Please_select_a_time: '请选择时间',
      Please_choose_a_week: '请选择星期',
      Please_choose_a_start_time: '请选择开始时间',
      Please_select_an_end_time: '请选择结束时间',
      Please_enter_your_phone_number: '请输入电话号码',
      Please_enter_the_positioning_time_interval: '请输入定位时间间隔',
      Please_enter_the_dial_style_number: '请输入表盘样式编号',
      Please_enter_the_volume_of_the_watch: '请输入手表音量',
      Please_input_the_brightness_of_the_watch: '请输入手表亮度',
      Please_enter_IMEI: '请输入IMEI',
      Please_enter_the_command_to_be_sent: '请输入需要发送的指令',
      lat: '纬度',
      lng: '经度',
      Invalid_latitude_format: '请输入正确的纬度',
      Invalid_longitude_format: '请输入正确的经度',
      Please_input_latitude: '请输入纬度',
      Please_input_longitude: '请输入经度',
      SwitchOFF: '关',
      SwitchON: '开',
      noempty: '不可为空',
      Canonlyint: '只能为非负整数',
      Canonlydecimal: '只能为非负数',
      Nummessag: '消息数量',
      domainname: '目标服务器域名',
      port: '端口',
      PleaseEnterAPPID: '请输入应用ID',
      ChatType: '聊天类型',
      Chatprivate: '单聊',
      Chatgroup: '群聊',
      ChatfileType: '文件类型',
      Chattext: '文本',
      Chataudio: '语音',
      Chatimage: '图片',
      Chatfile: '文件',
      Chatfileupload: '文件上传',
      ChatUserID: '用户ID',
      Add: '新增',
      Delete: '删除',
      Modify: '修改',
      status: '状态',
      ContactID: '联系人ID',
      SenderID: '发送者ID',
      Type: '类型',
      Domainname: '域名',
      UItype: 'UI类型',
      volumelevel: '音量等级',
      Alarmclockname: '闹钟名称',
      Separateswitch: '单独开关',
      Ringtype: '铃声类型',
      ImageID: '图片ID',
      Alarmpromptswitch: '报警提示开关',
      Level: '等级',
      Close: '关闭',
      Durationminutes: '时长(分钟)',
      Interval: '间隔时间',
      Timeperiod: '时间段',
      Durationseconds: '时长(秒)',
      switchstatus: '开关状态',
      powersupply: '电源',
      Lowpressure: '低压值',
      Highvoltage: '高压值',
      Highestbgalarm: '最高血糖报警值',
      Lowestbgalarm: '最低血糖报警值',
      Minhypotension: '低血压舒张压',
      Maxhypotension: '低血压收缩压',
      Minhypertension: '高血压舒张压',
      Maxhypertension: '高血压收缩压',
      Maxbloodoxygen: '血氧最高值',
      Minbloodoxygen: '血氧最低值',
      Maxheartrate: '心率最高值',
      Minheartrate: '心率最低值',
      heartrate: '心率',
      bloodoxygen: '血氧',
      hypertension: '高血压',
      hypotension: '低血压',
      lonlatplaceholder: "格式为：经度｜纬度",
      MACaddress: 'MAC地址',
      latlon: '经纬度',
      Switchno: '否',
      Switchis: '是',
      lonlatplaceholder2: "格式为：纬度,经度",
      Hrbo: '心率/血氧',
      bloodpressure: '血压',
      temperature: '温度',
      wear: '佩戴',
      sedentary: '久坐',
      LPAcode: 'LPA码',
      name: '名称',
      AvatarID: '头像ID',
      IsSOS: '是否SOS',
      telephone: '电话',
      GuardingTheme: '守护主题',
      WiFiName: 'WiFi名称',
      Wifip: 'WiFi密码',
      MobilehotspotMAC: '手机热点MAC地址',
      Searchinterval: '搜索间隔（单位秒）',
      dial: '拨号',
      Voicechat: '语聊',
      videocall: '视频通话',
      camera: '相机',
      Addfriend: '加好友',
      classschedule: '课表',
      exercise: '运动',
      NopermisNoIMEI: '无权监听或IMEI不存在',
      NoIMEI: 'IMEI不存在',
      IMEIformatincorrect: 'IMEI格式不正确',
    }
  },
  DataBoard: {
    Title: {
      title: '瑞腾智能数据平台',
      Device: '设备数据',
      Customer: '客户分布',
      BUser: 'B端用户',
      Country: '国家',
      DeviceGrowth: '设备增长',
      UsersTotal: '用户总数',
      DevicesTotal: '设备总数',
      DevicesOnlineTotal: '设备总数',
      CustomerType: '用户类型',
      Function: '功能激活次数',
      Warning: '预警信息',
    },
    Functions: {
      Step: '记步',
      Sleep: '睡眠',
      HeartRate: '心率',
      BloodPressure: '血压',
      BloodOxygen: '血氧',
    },
    ThisMonth: '本月',
    LastMonth: '上月',
    DeviceType: {
      Children: '儿童',
      OldPeople: '老人',
      QUBE: '车机',
      Luggage: '行李箱',
      Positioner: '定位器',
      PoliceLocator: '警用定位器',
    }
  },
  BTOnlineDial: {
    DialName: '表盘名称',
    DelContent: '是否确认删除此表盘,表盘删除后将无法恢复',
    UploadThumbnailFile: '上传缩略图文件',
    UploadBINFile: '上传BIN文件',
    OnlySupportsBinFiles: '只支持.bin文件',
    Table: {
      BinFileDownloadUrl: 'BIN文件下载地址',
      PictrueDownloadUrl: '表盘缩略图下载地址'
    },
    BluetoothOnlineDialList: '蓝牙在线表盘列表',
    RulerTips: {
      PleaseUploadAThumbnailFile: '请上传缩略图文件',
      PleaseUploadBINFile: '请上传BIN文件',
    },
    DelMsg1: "确定删除",
    DelMsg2: "表盘吗?",
    AddBTOnlineDial: "添加蓝牙手表表盘",
    EditBTOnlineDial: "编辑蓝牙手表表盘",
  },
  SysCountry: {
    中国: '中国',
    朝鲜: '朝鲜',
    韩国: '韩国',
    蒙古: '蒙古',
    日本: '日本',
    越南: '越南',
    老挝: '老挝',
    柬埔寨: '柬埔寨',
    缅甸: '缅甸',
    泰国: '泰国',
    马来西亚: '马来西亚',
    文莱: '文莱',
    新加坡: '新加坡',
    印度尼西亚: '印度尼西亚',
    东帝汶: '东帝汶',
    菲律宾: '菲律宾',
    印度: '印度',
    尼泊尔: '尼泊尔',
    不丹: '不丹',
    孟加拉: '孟加拉',
    斯里兰卡: '斯里兰卡',
    马尔代夫: '马尔代夫',
    巴基斯坦: '巴基斯坦',
    阿富汗: '阿富汗',
    哈萨克斯坦: '哈萨克斯坦',
    乌兹别克斯坦: '乌兹别克斯坦',
    土库曼斯坦: '土库曼斯坦',
    吉尔吉斯坦: '吉尔吉斯坦',
    塔吉克斯坦: '塔吉克斯坦',
    伊朗: '伊朗',
    格鲁吉亚: '格鲁吉亚',
    阿塞拜疆: '阿塞拜疆',
    亚美尼亚: '亚美尼亚',
    伊拉克: '伊拉克',
    科威特: '科威特',
    沙特阿拉伯: '沙特阿拉伯',
    巴林: '巴林',
    卡塔尔: '卡塔尔',
    阿联酋: '阿联酋',
    阿曼: '阿曼',
    也门: '也门',
    叙利亚: '叙利亚',
    黎巴嫩: '黎巴嫩',
    约旦: '约旦',
    塞浦路斯: '塞浦路斯',
    巴勒斯坦: '巴勒斯坦',
    以色列: '以色列',
    土耳其: '土耳其',
    挪威: '挪威',
    瑞典: '瑞典',
    芬兰: '芬兰',
    冰岛: '冰岛',
    丹麦: '丹麦',
    爱沙尼亚: '爱沙尼亚',
    拉脱维亚: '拉脱维亚',
    立陶宛: '立陶宛',
    白俄罗斯: '白俄罗斯',
    乌克兰: '乌克兰',
    摩尔多瓦: '摩尔多瓦',
    俄罗斯: '俄罗斯',
    德国: '德国',
    波兰: '波兰',
    捷克: '捷克',
    斯洛伐克: '斯洛伐克',
    匈牙利: '匈牙利',
    罗马尼亚: '罗马尼亚',
    保加利亚: '保加利亚',
    斯洛文尼亚: '斯洛文尼亚',
    克罗地亚: '克罗地亚',
    波黑: '波黑',
    塞尔维亚: '塞尔维亚',
    黑山: '黑山',
    北马其顿: '北马其顿',
    希腊: '希腊',
    阿尔巴尼亚: '阿尔巴尼亚',
    英国: '英国',
    爱尔兰: '爱尔兰',
    荷兰: '荷兰',
    比利时: '比利时',
    卢森堡: '卢森堡',
    法国: '法国',
    摩纳哥: '摩纳哥',
    西班牙: '西班牙',
    葡萄牙: '葡萄牙',
    安道尔: '安道尔',
    瑞士: '瑞士',
    列支敦士登: '列支敦士登',
    奥地利: '奥地利',
    意大利: '意大利',
    梵蒂冈: '梵蒂冈',
    圣马力诺: '圣马力诺',
    马耳他: '马耳他',
    埃及: '埃及',
    利比亚: '利比亚',
    摩洛哥: '摩洛哥',
    突尼斯: '突尼斯',
    毛里塔尼亚: '毛里塔尼亚',
    马里: '马里',
    塞内加尔: '塞内加尔',
    冈比亚: '冈比亚',
    阿尔及利亚: '阿尔及利亚',
    布基纳法索: '布基纳法索',
    佛得角: '佛得角',
    几内亚比绍: '几内亚比绍',
    几内亚: '几内亚',
    塞拉利昂: '塞拉利昂',
    利比里亚: '利比里亚',
    科特迪瓦: '科特迪瓦',
    加纳: '加纳',
    多哥: '多哥',
    贝宁: '贝宁',
    尼日尔: '尼日尔',
    尼日利亚: '尼日利亚',
    喀麦隆: '喀麦隆',
    赤道几内亚: '赤道几内亚',
    圣多美和普林西比: '圣多美和普林西比',
    乍得: '乍得',
    苏丹: '苏丹',
    南苏丹: '南苏丹',
    中非: '中非',
    埃塞俄比亚: '埃塞俄比亚',
    厄立特里亚: '厄立特里亚',
    索马里: '索马里',
    吉布提: '吉布提',
    肯尼亚: '肯尼亚',
    乌干达: '乌干达',
    坦桑尼亚: '坦桑尼亚',
    卢旺达: '卢旺达',
    布隆迪: '布隆迪',
    刚果: '刚果',
    加蓬: '加蓬',
    安哥拉: '安哥拉',
    赞比亚: '赞比亚',
    马拉维: '马拉维',
    莫桑比克: '莫桑比克',
    科摩罗: '科摩罗',
    马达加斯加: '马达加斯加',
    塞舌尔: '塞舌尔',
    毛里求斯: '毛里求斯',
    纳米比亚: '纳米比亚',
    博茨瓦纳: '博茨瓦纳',
    津巴布韦: '津巴布韦',
    南非: '南非',
    斯威士兰: '斯威士兰',
    莱索托: '莱索托',
    澳大利亚: '澳大利亚',
    巴布亚新几内亚: '巴布亚新几内亚',
    索罗门群岛: '索罗门群岛',
    新西兰: '新西兰',
    帕劳: '帕劳',
    纽埃: '纽埃',
    瑙鲁: '瑙鲁',
    密克罗尼西亚: '密克罗尼西亚',
    马绍尔群岛: '马绍尔群岛',
    库克群岛: '库克群岛',
    图瓦卢: '图瓦卢',
    汤加: '汤加',
    基里巴斯: '基里巴斯',
    瓦努阿图: '瓦努阿图',
    斐济: '斐济',
    萨摩亚: '萨摩亚',
    加拿大: '加拿大',
    美国: '美国',
    墨西哥: '墨西哥',
    危地马拉: '危地马拉',
    伯利兹: '伯利兹',
    萨尔瓦多: '萨尔瓦多',
    洪都拉斯: '洪都拉斯',
    尼加拉瓜: '尼加拉瓜',
    哥斯达黎加: '哥斯达黎加',
    巴拿马: '巴拿马',
    古巴: '古巴',
    牙买加: '牙买加',
    巴哈马: '巴哈马',
    海地: '海地',
    多米尼加: '多米尼加',
    安提瓜和巴布达: '安提瓜和巴布达',
    圣基茨和尼维斯: '圣基茨和尼维斯',
    多米尼克: '多米尼克',
    圣卢西亚: '圣卢西亚',
    圣文森特和格林纳丁斯: '圣文森特和格林纳丁斯',
    巴巴多斯: '巴巴多斯',
    格林纳达: '格林纳达',
    特立尼达和多巴哥: '特立尼达和多巴哥',
    哥伦比亚: '哥伦比亚',
    委内瑞拉: '委内瑞拉',
    秘鲁: '秘鲁',
    厄瓜多尔: '厄瓜多尔',
    玻利维亚: '玻利维亚',
    巴拉圭: '巴拉圭',
    圭亚那: '圭亚那',
    苏里南: '苏里南',
    巴西: '巴西',
    智利: '智利',
    阿根廷: '阿根廷',
    乌拉圭: '乌拉圭',

  },
  OnlineDialList:{
    DialName:"表盘名称",
    ModelName:"设备型号",
    Id:"表盘ID",
    DialCode:"表盘标识",
    DeviceModelName:"设备型号",
    ThumbnailUrl:"展示图URL",
    Thumbnailimg:"表盘展示图",
    ZipBagUrl:"表盘数据包URL",
    ZipBag:"表盘数据包",
    DialType:"表盘类型",
    DialShape:"表盘形状",
    DialSize:"表盘尺寸",
    VersionNumber:"版本号",
    DeleteOnlineDialTips:"删除后将无法恢复数据",
    DeleteOnlineDialTips1: "确认删除名为：“",
    DeleteOnlineDialTips2: "”的在线表盘吗？",
    AddOnlineDial:"新增表盘",
    EditOnlineDial:"修改表盘",
    UploadFileMsg2: "只支持：.jpg/.jpeg/.png格式的文件",
    UploadFileMsg3: "只支持：.zip格式的文件",
    DialType1: "模拟表盘",
    DialType2: "数字表盘",
    DialShape1: "圆形",
    DialShape2: "方形",
    ExportMsg: '正在导出，请稍后……',
    ExportToExcelName: "在线表盘列表_",
    DeleteOnlineDialmsg: "已成功删除标识为：'",
    DeleteOnlineDialmsg1: "'的在线表盘",
    SelectFile: '请选择文件上传',
    UploadFilefail: "提交失败，已有数据存在，如需修改请选择对应数据修改",
    UpdateFile: "此在线表盘已存在，已自动为你更新",
    rules:{
      DeviceModelName:"请选择设备型号",
      DialName:"请输入表盘名称",
      DialCode:"请输入表盘标识",
      DialShape:"请选择表盘形状",
      DialSize:"请选择表盘尺寸",
      DialCodeonOnly:"当前标识已经存在",
      DialCodeError:"请重新输入",
      DialCodetest:"只能输入字母、数字或下划线",
      DialType:"请选择表盘类型",
      DialShape:"请选择表盘形状",
      VersionNumber:"请输入版本号",
    }
  },
  APNmgr:{
    Continent:"洲",
    Operator_name:"运营商名称",
    DeleteStr:{
      Content:"确认要删除这条APN吗？",
      Content1:"确认是否删除这条APN配置,APN配置删除后无法恢复。"
    },
    Uiorder:"优先级",
    MVNO_Type:"虚拟运营商类型",
    MVNO_Value:"虚拟运营商类型筛选值",
    MCC:"移动国家码",
    MNC:"移动网络码",
    Account_Type:"APN 类型",
    APN:"接入点名称",
    Access_type:"接入类型",
    Access_Option:"是否允许终端用户编辑",
    Proxy_Server_IP:"网关地址",
    Port:"端口",
    User_Name:"用户名",
    Password:"密码",
    Auth_Type:"认证类型",
    Reserved:"IP类型",
    Visible:"是否对终端用户可见",
    Confirmed:"是否已确认",
    Roaming:"是否支持漫游",
    Confirmed:"是否已确认",
    roaming_protocol:"IP类型(漫游状态)",
    Asia:"亚洲",
    Europe:"欧洲",
    Africa:"非洲",
    Oceania:"大洋洲",
    North_America:"北美洲",
    South_America:"南美洲",
    rules:{
      MCC:"请输入MCC",
      MNC:"请输入MNC",
    },
    Import_instructions:"导入说明",
    Export_method:"导出方式",
    Export:"导出",
    Single_import:"单个导入",
    Excel_import:"Excel导入",
    XML_import:"Xml导入",
    Excel_import_Tip1:"如果您不知道导入数据的格式，请先",
    Excel_import_Tip2:"下载Excel导入模板",
    Xml_import_Tip:"只支持.xml文件",
    Need_File:"请至少上传一个文件！",
    OnlyExcel:"只能上传.xlsx/.xls文件！",
    OnlyXml:"只能上传.xml文件！",
    ExistsApn:"系统已存在APN列表",
    APN_Import_Template:"APN导入模板"
  },
  OnlineProtocolDoc:{
    wordcompany:"瑞腾",
    wordtitle:"瑞腾智能手表协议",
    worddescription:"瑞腾智能手表协议文档，仅供参考",
    wordtext:"瑞腾",
    wordtext2:"智能手表协议文档",
    Example:"示例",
    ExampleExplanation:"示例说明",
    success:"导出成功",
    fail:"导出失败",
    PlatformResponse:"平台响应",
    DeviceResponse:"设备响应",
    ProtocolDescription:"文档说明",
    SendingCommand:"发送指令",
    CommandCode:"指令标识",
    Orderindex:"排序",
    ProtocolContent:"内容",
    Title:"标题",
    Type:"类型",
    Add:"新增",
    ViewDocument:"查看文档",
    DeleteDocMsg:"是否删除协议，删除后无法恢复哦！",
    DeleteDocmsgtitle2: '确定要删除名为"',
    DeleteDocmsgtitle3: '"协议吗？',
    rulesTitle: '请输入标题',
    rulesTitleEN: '请输入英文标题',
    rulesCommandCode: '请输入正确的标识',
    rulesType: '请选择一项',
    DisplayLocation: '显示位置:',
    top: '上',
    right: '右',
    bottom: '下',
    left: '左',
    ExportToWord: '导出 Word',
    ExportToWordName: '协议文档',
    OnlineProtocolDocNULL: '该设备型号暂无绑定数据',
    form:{
      ParentId:"上级菜单",
      Title:"标题",
      TitleEN:"英文标题",
      Example:"示例",
      ExampleEN:"英文示例",
      ExampleExplanation:"示例说明",
      ExampleExplanationEN:"英文示例说明",
      PlatformResponse:"平台响应",
      PlatformResponseEN:"英文平台响应",
      DeviceResponse:"设备响应",
      DeviceResponseEN:"英文设备响应",
      ProtocolDescription:"文档说明",
      ProtocolDescriptionEN:"英文文档说明",
      CommandCode:"指令标识",
      Type:"类型",
      Type1:"菜单",
      Type2:"上行指令",
      Type3:"下行指令",
    },
  },
  LogQuery:{
    IMEIplaceholder:'可只输入IMEI最后3位',
    Created:'日期',
    ServiceName:'服务名称',
    togglePause1:'停止更新',
    togglePause2:'后更新',
    Flushed1:'只看最新记录',
    IMEIwarn:'请输入IMEI',
    exporttexterr:'数据有误',
    lognullwarn:'暂无日志',
    hovelogservicename:'该IMEI只有这些服务有日志:',
    ToolTipmessage:'确定导出为txt文件吗？',
    ReceivingData: '正在接收日志记录...',
  },
  LocationCount:{
    Equipment_positioning_frequency_report:'设备定位次数报表',
    Customer_targeting_proportion:'客户定位占比',
    CustomerTimeSelect:{
      in_the_past_month:'近一个月',
      in_the_past_day:'近一天',
      in_the_past_hour:'近一小时',
    },
    Query_of_device_positioning_times:'设备定位次数查询',
    DeviecTableSelect:{
      hours_24:'24小时',
      days_7:'7天',
      days_14:'14天',
      a_month:'1个月'
    },
    Server_positioning_trend:'服务器定位趋势',
    Server_positioning_times:'服务器定位次数',
    ServerTabs:{
      last_7_days:'近7天',
      last_24_hours:'近24小时',
    }
  }
}